<div class="p-5">

  <!-- Header -->
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
    <h1 class="text-2xl font-bold text-gray-800 mb-4 md:mb-0">
      <mat-icon class="text-aguacate-green mr-2">receipt_long</mat-icon>
      Transacciones VES Completadas
      <span *ngIf="totalItems"
        class="text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
        {{ totalItems }} registros
      </span>
    </h1>
  </div>

  <!-- Filtros - Card centrada y compacta -->
  <div class="flex justify-center mb-6">
    <div class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">

      <div class="text-center mb-6">
        <h3 class="text-lg font-semibold text-gray-700 flex items-center justify-center">
          <mat-icon class="text-aguacate-green mr-2">filter_list</mat-icon>
          Filtros de Búsqueda
        </h3>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Buscar</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="text" (keyup)="doFilter($event)" placeholder="Nombre, email, ID...">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Rango de fechas</mat-label>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Inicio">
            <input matEndDate formControlName="end" placeholder="Fin">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
          <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Fecha inicio inválida</mat-error>
          <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Fecha fin inválida</mat-error>
        </mat-form-field>

        <div class="flex items-center justify-center">
          <button (click)="loadTransactions()"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;" onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px;">search</mat-icon>
            Buscar
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- Tabla de transacciones (solo desktop) -->
  <div class="hidden lg:block overflow-auto border rounded-lg shadow-md bg-white" *ngIf="dataSource">
    <table mat-table [dataSource]="dataSource" class="w-full table-responsive">

      <!-- Columna ID -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">
          ID
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono">
          {{ row.id }}
        </td>
      </ng-container>

      <!-- Columna Fecha Creación -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">
          Fecha Creación
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <div class="text-xs font-medium">{{ getDateOnly(row.createdAt) }}</div>
          <div class="text-xs font-medium">{{ getTimeOnly(row.createdAt) }}</div>
        </td>
      </ng-container>

      <!-- Columna Fecha Término -->
      <ng-container matColumnDef="fechaTermino">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold hide-on-mobile">
          Fecha Término
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 hide-on-mobile">
          <div class="text-xs font-medium">{{ getDateOnly(row.fechaTermino) }}</div>
          <div class="text-xs font-medium">{{ getTimeOnly(row.fechaTermino) }}</div>
        </td>
      </ng-container>

      <!-- Columna ID Cliente -->
      <ng-container matColumnDef="clienteId">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">
          ID Cliente
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono">
          {{ row.userId }}
        </td>
      </ng-container>

      <!-- Columna Nombre Usuario -->
      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold">
          Usuario
        </th>
        <td mat-cell *matCellDef="let row" class="text-left p-2">
          <div class="font-medium text-sm">{{ row.usuario?.nombre || '' }} {{ row.usuario?.apellidos || '' }}</div>
          <div class="text-xs font-bold font-mono">ID: {{ row.userId }}</div>
        </td>
      </ng-container>

      <!-- Columna Operador -->
      <ng-container matColumnDef="operador">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold hide-on-mobile">
          Completada por
        </th>
        <td mat-cell *matCellDef="let row" class="text-left p-2 text-xs hide-on-mobile">
          {{ row.emailOperador || 'No aplica' }}
        </td>
      </ng-container>

      <!-- Columna Cajero de Pago -->
      <ng-container matColumnDef="cuentaTrabajo">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold hide-on-mobile">
          Cajero de Pago
        </th>
        <td mat-cell *matCellDef="let row" class="text-left p-2 hide-on-mobile">
          <ng-container *ngIf="row.cuentaTrabajo">
            <div class="font-medium text-xs">{{ row.cuentaTrabajo.nombre }} {{ row.cuentaTrabajo.apellidos }}</div>
            <div class="text-xs text-blue-600 font-semibold">{{ row.cuentaTrabajo.banco?.nombre || 'Sin banco' }} - {{ row.cuentaTrabajo.numeroCuenta }}</div>
          </ng-container>
          <span *ngIf="!row.cuentaTrabajo" class="text-xs">No aplica</span>
        </td>
      </ng-container>

      <!-- Columna Beneficiario -->
      <ng-container matColumnDef="cuentaBeneficiarioId">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold">
          Beneficiario
        </th>
        <td mat-cell *matCellDef="let row" class="text-left p-2">
          <div class="font-medium text-xs">{{ row.cuentaBeneficiario?.nombre || '' }} {{ row.cuentaBeneficiario?.apellidos || '' }}</div>
          <div class="text-xs text-gray-400">{{ row.cuentaBeneficiario?.numeroCuenta || '' }}</div>
        </td>
      </ng-container>

      <!-- Columna Ruta -->
      <ng-container matColumnDef="ruta">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold hide-on-mobile">
          Ruta
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs hide-on-mobile">
          {{ row.paisOrigen }} - {{ row.paisDestino }}
        </td>
      </ng-container>

      <!-- Columna Tipo Transacción -->
      <ng-container matColumnDef="tipoTransaccion">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold hide-on-mobile">
          Tipo Transacción
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs hide-on-mobile">
          <span class="px-2 py-0.5 rounded-full text-xs font-semibold"
            [style.background]="row.tipoTransaccion === 'FIAT' ? '#f0fdf4' : '#eff6ff'"
            [style.color]="row.tipoTransaccion === 'FIAT' ? '#16a34a' : '#2563eb'">
            {{ row.tipoTransaccion === 'SWAP_USDT_VES' ? 'Swap USDT → VES' : row.tipoTransaccion === 'FIAT' ? 'Fiat' : (row.tipoTransaccion || 'No aplica') }}
          </span>
        </td>
      </ng-container>

      <!-- Columna Banco Destino -->
      <ng-container matColumnDef="bancoDestino">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold hide-on-mobile">
          Banco Destino
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs hide-on-mobile">
          {{ row.cuentaBeneficiario?.banco?.nombre || 'Sin banco' }}
        </td>
      </ng-container>

      <!-- Columna Monto Origen -->
      <ng-container matColumnDef="totalMonedaOrigen">
        <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold">
          Monto Origen
        </th>
        <td mat-cell *matCellDef="let row" class="text-right p-2 text-xs font-bold text-green-600">
          {{ row.totalMonedaOrigen | currency:'$' }}
        </td>
      </ng-container>

      <!-- Columna Monto Destino -->
      <ng-container matColumnDef="totalMonedaDestino">
        <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold">
          Monto Destino
        </th>
        <td mat-cell *matCellDef="let row" class="text-right p-2 text-xs font-bold text-green-600">
          {{ row.totalMonedaDestino | currency:'$' }}
        </td>
      </ng-container>

      <!-- Columna Tasa Pagada VES -->
      <ng-container matColumnDef="tasa">
        <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold">
          Tasa VES
        </th>
        <td mat-cell *matCellDef="let row" class="text-right p-2 text-xs font-bold text-purple-600">
          {{ row.tasa | number:'1.2-4' }}
        </td>
      </ng-container>

      <!-- Columna Estado -->
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">
          Estado
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <span class="px-2 py-1 inline-flex text-xs leading-5 font-bold rounded-full"
            [style.background]="getStatusBg(row)"
            [style.color]="getStatusColor(row)">
            {{ row.estado.replaceAll('_', ' ') || 'Sin estado' }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="hover:bg-gray-100 transition-colors"></tr>
    </table>

  </div>

  <!-- Paginador (visible en todas las vistas) -->
  <div class="flex justify-center my-3">
    <mat-paginator #paginator
      (page)="onPageChange($event)"
      [length]="totalItems"
      [pageSize]="pageSize"
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [pageIndex]="currentPage - 1"
      class="rounded-lg border border-gray-200 shadow-sm">
    </mat-paginator>
  </div>

  <!-- ═══ Mobile / Tablet Cards ═══ -->
  <div class="lg:hidden">
    <div *ngIf="!dataSource || !transacciones?.length"
      style="text-align: center; padding: 40px 20px;">
      <mat-icon style="color: #d1d5db; font-size: 48px; width: 48px; height: 48px;">receipt_long</mat-icon>
      <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px;">No se encontraron transacciones</p>
    </div>

    <div *ngFor="let row of transacciones"
      style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 10px;">

      <!-- Card header -->
      <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px 16px; background: #f9fafb; border-bottom: 1px solid #f3f4f6;">
        <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
          <span style="background: #dcfce7; color: #1e5a3f; font-size: 0.75rem; padding: 2px 8px; border-radius: 10px; font-weight: 600;">
            #{{ row.id }}
          </span>
          <span style="font-size: 0.7rem; padding: 3px 10px; border-radius: 10px; font-weight: 700; white-space: nowrap;"
            [style.background]="getStatusBg(row)"
            [style.color]="getStatusColor(row)">
            {{ row.estado.replaceAll('_', ' ') || 'Sin estado' }}
          </span>
          <span style="background: #eff6ff; color: #1d4ed8; font-size: 0.7rem; padding: 2px 8px; border-radius: 10px; font-weight: 600;">
            {{ row.paisOrigen }} → {{ row.paisDestino }}
          </span>
        </div>
      </div>

      <!-- Card body -->
      <div style="padding: 12px 16px; background: white;">
        <div class="grid grid-cols-2 gap-x-12 gap-y-1">

          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">ID Cliente</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ row.userId }}</span>
          </div>

          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Usuario</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
              {{ row.usuario.nombre || '' }} {{ row.usuario.apellidos || '' }}
            </span>
          </div>

          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fecha creación</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.8rem;">{{ getDateFormatted(row.createdAt) }}</span>
          </div>

          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fecha término</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.8rem;">{{ getDateFormatted(row.fechaTermino) }}</span>
          </div>

          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto origen</span>
            <span style="color: #1e5a3f; font-weight: 700; font-size: 0.9rem;">{{ row.totalMonedaOrigen | currency:'$' }}</span>
          </div>

          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto destino</span>
            <span style="color: #1e5a3f; font-weight: 700; font-size: 0.9rem;">{{ row.totalMonedaDestino | currency:'$' }}</span>
          </div>

          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Tasa pagada VES</span>
            <span style="color: #7c3aed; font-weight: 700; font-size: 0.9rem;">{{ row.tasa | number:'1.2-4' }}</span>
          </div>

          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Beneficiario</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
              {{ row.cuentaBeneficiario.nombre || '' }} {{ row.cuentaBeneficiario.apellidos || '' }}
              <span *ngIf="row.cuentaBeneficiario.numeroCuenta" style="color: #6b7280;">
                | {{ row.cuentaBeneficiario.numeroCuenta }}
              </span>
            </span>
          </div>

          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Banco destino</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
              {{ row.cuentaBeneficiario.banco?.nombre || 'Sin banco' }}
            </span>
          </div>

          <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Completada por</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem; word-break: break-all;">
              {{ row.emailOperador || 'No aplica' }}
            </span>
          </div>

          <div *ngIf="row.cuentaTrabajo" style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Cajero de pago</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
              {{ row.cuentaTrabajo.nombre }} {{ row.cuentaTrabajo.apellidos }}
              - {{ row.cuentaTrabajo.banco?.nombre || 'Sin banco' }}
              - {{ row.cuentaTrabajo.numeroCuenta }}
            </span>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>
